export function sentryTunnelFromDSN(dsn: string) {
  const url = new URL(dsn);
  const project = url.pathname.replace(/^\/+/, '').split('/')[0];
  return `/.proxy/sentry/api/${project}/envelope/`;
}
